// extracted by mini-css-extract-plugin
module.exports = {"list":"NumberedCardList_list__3dHl0","withTitle":"NumberedCardList_withTitle__CGmFX","item":"NumberedCardList_item__orasK"};